import Vue from "vue";

class User {
  constructor(address, amount_total, birthday, cellphone, city, confirmation, country_id, created_at, customer_id,
              department_id, discount, email, email_notification, email_verified, first_name, full_name,
              google_access_token, google_refresh_token, group_id, id, ip_address, is_active, is_super_admin,
              language, last_name, lastlogin, mailbox, phone, send_confirmation,
              ssl_avs_address, ssl_avs_zip, state, street_1, street_2, token, updated_at, user_points, username,
              zip, gender, is_confirm_tc, level, paymentProfiles, level_orders_count, paypal_setup_token,
              paypal_payment_token) {
    this.address = address
    this.amount_total = amount_total
    this.birthday = birthday
    this.cellphone = cellphone
    this.city = city
    this.confirmation = confirmation
    this.country_id = country_id
    this.created_at = created_at
    this.customer_id = customer_id
    this.department_id = department_id
    this.discount = discount
    this.email = email
    this.email_notification = email_notification
    this.email_verified = email_verified
    this.first_name = first_name
    this.full_name = full_name
    this.google_access_token = google_access_token
    this.google_refresh_token = google_refresh_token
    this.group_id = group_id
    this.id = id
    this.ip_address = ip_address
    this.is_active = is_active
    this.is_super_admin = is_super_admin
    this.language = language
    this.last_name = last_name
    this.lastlogin = lastlogin
    this.mailbox = mailbox
    this.phone = phone
    this.send_confirmation = send_confirmation
    this.ssl_avs_address = ssl_avs_address
    this.ssl_avs_zip = ssl_avs_zip
    this.state = state
    this.street_1 = street_1
    this.street_2 = street_2
    this.token = token
    this.updated_at = updated_at
    this.user_points = user_points
    this.username = username
    this.zip = zip
    this.gender = gender
    this.is_confirm_tc = is_confirm_tc
    this.level = level
    this.paymentProfiles = paymentProfiles
    this.level_orders_count = level_orders_count
    this.paypal_setup_token = paypal_setup_token
    this.paypal_payment_token = paypal_payment_token
  }
}

export default {
  state: {
    user: null,
    phone: null
  },
  mutations: {
    setUser(state, payload) {
      if (payload) {
        state.user = payload
        localStorage.setItem('user', JSON.stringify(payload))
      } else {
        if (localStorage.getItem('user')) {
          localStorage.removeItem('user')
        }
        state.user = null
      }
    },
    setPhone(state, payload) {
      if (payload)
        state.phone = payload
    },
    setPoints(state, payload) {
      if (payload)
        state.user.user_points = payload
    },
  },
  actions: {
    removeUser({commit}) {
      commit('setUser', null)
      localStorage.removeItem('access_token')
      localStorage.removeItem('refresh_token')
    },
    userLogging ({state}) {
      return new Promise((resolve, reject) => {
        if (state.user !== null) {
          resolve()
        } else {
          reject()
        }
      })
    },
    createNewUser({commit}, payload) {
      commit('clearError')
      commit('setLoading', true)
      try {
        let u = new User(
          payload.address,
          payload.amount_total,
          payload.birthday,
          payload.cellphone,
          payload.city,
          payload.confirmation,
          payload.country_id,
          payload.created_at,
          payload.customer_id,
          payload.department_id,
          payload.discount,
          payload.email,
          payload.email_notification,
          payload.email_verified,
          payload.first_name,
          payload.full_name,
          payload.google_access_token,
          payload.google_refresh_token,
          payload.group_id,
          payload.id,
          payload.ip_address,
          payload.is_active,
          payload.is_super_admin,
          payload.language,
          payload.last_name,
          payload.lastlogin,
          payload.mailbox,
          payload.phone,
          payload.send_confirmation,
          payload.ssl_avs_address,
          payload.ssl_avs_zip,
          payload.state,
          payload.street_1,
          payload.street_2,
          payload.token,
          payload.updated_at,
          payload.user_points,
          payload.username,
          payload.zip,
          payload.gender,
          payload.is_confirm_tc,
          payload.level,
          payload.paymentProfiles,
          payload.level_orders_count,
          payload.paypal_setup_token,
          payload.paypal_payment_token
        )
        commit('setUser', u)
        commit('setLoading', false)
      } catch (error) {
        commit('setLoading', false)
        commit('setError', error.message)
      }
    },
  },
  getters: {
    getPhone(state) {
      return state.phone
    },
    IS_LOGIN_USER: state => {
      return state.user !== null
    },
    IS_LOGIN_ADMIN: state => {
      return state.user && state.user.group_id === Vue.prototype.$userType.Admin
    },
    IS_LOGIN_SUPER_ADMIN: state => {
      return state.user && state.user.group_id === Vue.prototype.$userType.Admin && state.user.is_super_admin
    },
    user(state) {
      return state.user
    }
  }
}
